import React from "react";
import cn from "classnames";

import { StyledI } from "../styles";
import { IconBaseProps, IconComponent, IconProps } from "../types";

/** An icomoon glyph via <i className="icon-ic-*"> — the font is wired globally in src/index.tsx. */
const IconBase = React.forwardRef<HTMLElement, IconBaseProps>(
  ({ iconClass, className, fontSize = "medium", color, ...rest }, ref) => (
    <StyledI
      ref={ref}
      className={cn(iconClass, className)}
      $fontSize={fontSize}
      $color={color}
      {...rest}
    />
  )
);

export default IconBase;

export const makeIcon = (iconClass: string): IconComponent =>
  React.forwardRef<HTMLElement, IconProps>((props, ref) => (
    <IconBase ref={ref} iconClass={iconClass} {...props} />
  ));
